import Component from 'vue-class-component'
import moduleStore from '../store/index';
import Vue from 'vue';
import PageState from '../store/state';
import StyleSpeedPopup from '../../videoEditor/components/styleSpeedPopup/styleSpeedPopup';
import videoContentPopup from '../../videoEditor/components/videoContentPopup/videoContentPopup';
import { judgeDeviceType } from "@/utils/device";
import {
  toast
} from '@/utils/util'
import { getDataStorage, saveDataStorage } from '../utils/saveDataStorage';
import to from 'await-to-js';

@Component({
  components: {
    StyleSpeedPopup,
    videoContentPopup,
  }
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames
})
export default class SmartClipStep4 extends Vue {
  state = new PageState();

  isApp = judgeDeviceType.isAPP;
  checkedIcon = this.$publicPath + 'images/video_editor/checked_1713866287568_icon.png';
  unCheckedIcon = this.$publicPath + 'images/smart_text/icon_unchecked_grey.png';
  noCheckIcon = this.$publicPath + 'images/smart_text/icon_nocheck.png';

  // 配音模式
  dubModeList = [
    {
      id: 1,
      text: '声音转换',
      desc: '（适用于文案不变化）',
      checked: false,
      disabled: true,
    }, {
      id: 2,
      text: '重新配音',
      desc: '（适用于更改过文案）',
      checked: true,
    }
  ];
  activeDubModeId = 2;

  // 高级设置
  settingList = [
    {
      id: 'toning',
      text: '智能调色',
      desc: '智能调整视频对比度、扫光效果',
      checked: true,
      ids: [
        'addContractAndLight', // 智能调色开关 - 视频对比度
        'sweep', // 智能调色开关 - 扫光效果
      ]
    }, {
      id: 'mirror',
      text: '智能镜像',
      desc: '智能镜像视频画面（内嵌文字）',
      checked: true,
      ids: [
        'lensFlip' // 智能镜像开关
      ]
    }, {
      id: 'jogging',
      text: '视频微动',
      desc: '智能进行画面移动',
      checked: true,
      ids: [
        'videoScroll' // 视频微动开关
      ]
    }, {
      id: 'pip',
      text: '画中画',
      desc: '智能添加视频水印、贴纸和背景',
      checked: true,
      ids: [
        'addWatermark', // 画中画开关 - 视频水印
        'addTransparentCartoon', // 画中画开关 - 贴纸
        'addTransparentBackground', // 画中画开关 - 背景
      ]
    }, {
      id: 'bgm',
      text: '声纹水印',
      desc: '智能添加声纹水印',
      checked: true,
      ids: [
        'addBgm', // 声纹水印开关
      ]
    }
  ];

  currSpeaker = {
    headerImage: 'https://mobvoi-growth-public.ticwear.com/image/moyingongfang/2023-11-03-8811501069080134477.jpeg',
    name: '魔云熙',
    code: 'No.5',
    speakerId: 0,
    speaker: '',
    speakerEmotionCacheVOList: []
  };
  defaultSpeaker = '魔云熙';
  emotionList = []; //所有情绪列表
  speakerEmotionList = []; //当前发音人情绪（风格）列表
  currSpeakerStyleId = 0; // 当前发音人风格id
  currSpeakerStyle = '默认'; //当前发音人风格
  currSpeed = '1.2'; // 当前倍速
  styleSpeedVisible = false; // 风格倍速弹窗显示

  isSubmiting = false;

  // 选择配音模式
  doSelect(item) {
    if (item.disabled || this.activeDubModeId === item.id) return;
    this.activeDubModeId = item.id;
  }
  doChangeSetting(index) {
    const item = this.settingList[index];
    item.checked = !item.checked;
    this.$set(this.settingList, index, item);
  }

  mounted() {
    (window as any)?.setTitle?.postMessage('4/4 设置视频参数');
    this.getLocalStorageStep4Data();
    this.querySpeakerData();
  }
  querySpeakerData() {
    Promise.all([
      this.getSpeakerEmotion(),
      this.getSearchSpeaker()
    ]).then(() => {
      this.handleEmotion();
    })
  }

   getLocalStorageStep4Data() {
    // 获取缓存数据
    const data = getDataStorage('step4');
    if (data && data.speakerName) {
      this.defaultSpeaker = data.speakerName;
      this.currSpeed = data.speechSpeed;
      this.currSpeakerStyle = data.speakerStyle;
      this.currSpeakerStyleId = data.speakerStyleId;
      saveDataStorage('step4', {});
    }
    // 获取发音人页面数据
    const currSpeaker = JSON.parse(localStorage.getItem('currSpeaker'));
    if (currSpeaker && currSpeaker.name) {
      this.defaultSpeaker = currSpeaker.name;
      localStorage.removeItem('currSpeaker');
    }
  }
  /**
   * 跳转发音人页面
   */
  doJumpSpeakerPage() {
    this.setLocalStorageData();
    this.$router.push({ path: `searchSpeaker?speakerId=${this.currSpeaker?.speakerId}&from=smart-clip-step4` })
  }
  // 本地存储数据，跳转其他页面（发音人搜索页）时进行存储
  setLocalStorageData() {
    const data = { 
      speakerName: this.currSpeaker.name, // 发音人名称，用于请求发音人详情
      speechSpeed: this.currSpeed, // 语速
      speakerStyle: this.currSpeakerStyle,  // 发音人风格
      speakerStyleId: this.currSpeakerStyleId,  // 发音人风格id
    };
    saveDataStorage('step4', data);
  }
  /**
   * 获取所有发音人情绪
   */
  async getSpeakerEmotion() {
    const res = await this.$http('getSpeakerEmotionList', {})
    if (res.data) {
      this.emotionList = res.data
    }
  }
  /**
   * 获取默认发音人
   */
  async getSearchSpeaker() {
    const res = await this.$http('getDefaultSpeaker', {
      page: 1,
      pageSize: 1,
      keyword: this.defaultSpeaker,
    })
    const { results } = res.data || {};
    if (results && results.length) {
      this.currSpeaker = results[0]
    }
  }
  /**
   * 处理当前发音人情绪列表
   */
  handleEmotion() {
    const speakerEmotionCacheVOList = this.currSpeaker.speakerEmotionCacheVOList
    this.speakerEmotionList = [];
    speakerEmotionCacheVOList.forEach((item) => {
      let emotionEn = item.speaker.split('@')[1] || 'default2';
      const emotionInfo = this.emotionList.find(v => v.emotion === emotionEn) || {};
      const emotionitem = { ...this.currSpeaker, ...item, ...emotionInfo };
      emotionitem.moodName = item.name.split('|')[1] || '默认';
      emotionitem.moodImg = emotionInfo.imageUrl;
      this.speakerEmotionList.push(emotionitem);
    })
    if (this.speakerEmotionList.length) {
      let index = this.speakerEmotionList.findIndex(item => item.speakerId === this.currSpeakerStyleId || item.moodName === this.currSpeakerStyle);
      index = index > -1 ? index : 0;
      this.currSpeakerStyleId = this.speakerEmotionList[index].speakerId;
      this.currSpeakerStyle = this.speakerEmotionList[index].moodName;
      this.currSpeaker.speaker = this.speakerEmotionList[index].speaker24k || this.speakerEmotionList[index].speaker;
    }
  }

  /**
   * 展示风格语速弹窗
   */
  showPopup(bol = true) {
    this.styleSpeedVisible = bol;
  }
  /**
   * 确定发音人语速，风格
   */
  confirmStyleSpeed(selectedStyleValue, selectedStyleName, selectedSpeedValue) {
    this.currSpeakerStyle = selectedStyleName || '默认';
    this.currSpeakerStyleId = selectedStyleValue;
    this.currSpeed = selectedSpeedValue;
    this.showPopup(false);
    // 风格修改后重设speaker
    let index = this.speakerEmotionList.findIndex(item => item.speakerId === this.currSpeakerStyleId || item.moodName === this.currSpeakerStyle);
    if(index > -1) {
      this.currSpeaker.speaker = this.speakerEmotionList[index].speaker24k || this.speakerEmotionList[index].speaker;
    }
  }


  // 提交
  loading = false;
  async doCreateSubmit() {
    this.loading = true
    // 修改任务的发音信息人
    const data = getDataStorage('step2')
    const segments = data.universal_segments || [];
    segments.forEach(item => {
      if (!item.is_silence) {
        item.s_speaker = this.currSpeaker.speaker;
        item.s_speaker_type = 2;
      }
    })
    const [err, res] = await to(this.$http('updateTranslateTaskParam', {
      task_id: data.taskId,
      paramsBean: {
        universal_segments: segments
      }
    }))
    if (err || res.code !== 200 || !res.data) {
      toast(res.message || '发音人修改失败');
      return this.loading = false;
    }
    this.getVipInfo()
      .then((res) => {
        if (res) {
          // 打开视频清单弹窗
          this.showVideoContentPopup()
        }
      }).finally(() => {
        this.loading = false
      })
  }

  /****************************** 视频清单 ******************************/
  // 判断用户是/否是会员
  isVip = false
  // 总生成次数
  totalGenerateCount = 0
  // 剩余生成次数
  leftGenerateCount = 0
  // 控制视频清单弹窗显/隐
  isVideoContentPopupVisible = false

  getVipInfo() {
    const ww_token = localStorage.getItem('ww_token');
    if(!ww_token) return Promise.resolve(false);
    return this.$http('queryMemberLeftRight')
      .then((res) => {
        const { code, data, message } = res
        if (code === 200) {
          // 会员权益
          this.isVip = data.vipRightsVO.isVip
          // 生成次数权益
          this.totalGenerateCount = data.totalRightsCountVO.totalCount
          this.leftGenerateCount = data.totalRightsCountVO.leftCount
          return data;
        } else {
          console.error(message)
          return false;
        }
      }).catch(err => {
        console.log('getVipInfo', err)
      })
  }

  /** 展示视频清单弹窗 */
  showVideoContentPopup() {
    this.isVideoContentPopupVisible= true
  }
  /** 隐藏视频清单弹窗 */
  hideVideoContentPopup() {
    this.isVideoContentPopupVisible = false
  }
  // 查询任务parameters
  async getParameters() {
    const taskId = getDataStorage('step2').taskId
    const [generateError, generateRes] = await to(this.$http('getTranslateTaskDetail', {
      taskId: taskId
    }));
    if (generateError || generateRes.code !== 200) {
      toast(generateRes.message || '查询视频解析状态失败');
      return;
    }
    const generateData = generateRes && generateRes.data || {};
    if(generateData.state !== 'PAUSED') return;
    return {
      translateTaskId: taskId,
      parameters:  generateData.parameters || []
    };
  }
   /** 确认生成视频 */
  async confirmGenerateVideo() {
    if (this.isSubmiting) return
    this.isSubmiting = true;
    const smartCut = await this.getParameters();
    if (!smartCut) return;
    const params: any = {
      speaker: this.currSpeaker.speaker,
      speakerStyle: this.currSpeakerStyle,
      speechSpeed: this.currSpeed,
      platform: this.isApp ? 'APP' : judgeDeviceType.isMobile ? 'MINI' : 'UNKNOWN',
      resourceType: 'SMART_CUT', // 智能剪辑
      deduplication: {},
      smartCutContent: getDataStorage('step1'),
      smartCut
    };
    this.settingList.forEach(item => {
      const { ids, checked } = item;
      ids.forEach(id => {
        params.deduplication[id] = checked;
      })
    })
    console.log('提交参数', params)
    const [err, res] = await to(this.$http('doSubmitArticle', params))
    this.isSubmiting = false;
    if (err || res.code !== 200 || !res.data) {
      toast(res.message || '提交失败');
      return;
    }
    this.jumpToNextPage(res.data.articleId);
  }

  //跳转到生成状态页面
  jumpToNextPage(articleId) {
    if (this.isApp) {
      const switchToArticleCreating: any = (<any>window).switchToArticleCreating
      switchToArticleCreating.postMessage(articleId)
    } else {
      this.$redirectTo({
        url: `/baohuo-package/pages/audio-creating/audio-creating?articleId=${articleId}`
      });
    }
  }
}